import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://vjvspwcwfbhehdlevnul.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'sb_publishable_1skJZN1H3XZDjOQab2IeHg_Yq0bt7N4'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
